/* eslint-disable camelcase */
import color from 'color';
import ShButton from '@/components/Helpers/ShButton';
import ShTextWrapper from '@/components/Helpers/ShTextWrapper';
import ShUserAvatar from '@/components/Helpers/ShUserAvatar';
import ShStarRating from '@/components/Helpers/ShStarRating';
import ShCustomStyle from '@/components/Helpers/ShCustomStyle';
import DepartmentSign from '@/components/Common/DepartmentSign';

// @vue/component
export default {
  name: 'ConnectionsListItem',

  components: {
    ShButton,
    ShTextWrapper,
    ShUserAvatar,
    ShStarRating,
    ShCustomStyle,
    DepartmentSign,
  },

  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      defaultNotifyStatus: {
        fa_icon: 'fa-refresh',
        color: '#4A4C54',
        description: '---',
      },
    };
  },

  computed: {
    notifyStatus() {
      const { notify_status } = this.item;
      return (this.$store.getters['connections/connectionsSettings'].notifyStatuses
        .find(notify => notify.status_name === notify_status)) || this.defaultNotifyStatus;
    },
    accessPermissionsDefinitions() {
      return this.$store.getters['authorization/accessPermissionsDefinitions'];
    },
    dynamicStyleAccordingToStatus() {
      return `
      .ConnectionsListItem--${this.notifyStatus.status_name} .ConnectionsListItem__connection-data {
          border: 1px solid ${color(this.notifyStatus.color).rgb().fade(0.8)};
          border-left: 3px solid ${this.notifyStatus.color};
          transition: all 0.3s;
        }

        .ConnectionsListItem--${this.notifyStatus.status_name} .ConnectionsListItem__connection-data:hover {
          border: 1px solid ${this.notifyStatus.color};
          border-left: 2px solid ${this.notifyStatus.color};
        }

        .ConnectionsListItem--${this.notifyStatus.status_name} .ConnectionsListItem__status-icon {
          box-shadow: 17px 17px 34px #141519, -17px -17px 34px #4a4f5d;
          color: #2F323B;
          background: ${this.notifyStatus.color};
        }
        .ConnectionsListItemMobile--${this.notifyStatus.status_name} .ConnectionsListItemMobile__connection-data {
          border: 1px solid ${color(this.notifyStatus.color).rgb().fade(0.8)};
          border-left: 3px solid ${this.notifyStatus.color};
          transition: all 0.3s;
        }

        .ConnectionsListItemMobile--${this.notifyStatus.status_name} .ConnectionsListItemMobile__connection-data:hover {
          border: 1px solid ${this.notifyStatus.color};
          border-left: 2px solid ${this.notifyStatus.color};
        }

        .ConnectionsListItemMobile--${this.notifyStatus.status_name} .ConnectionsListItemMobile__status-icon {
          box-shadow: 17px 17px 34px #141519, -17px -17px 34px #4a4f5d;
          color: #2F323B;
          background: ${this.notifyStatus.color};
        }
      `;
    },
  },

  methods: {
    setConnectionsDownloadParams(params) {
      this.$store.dispatch('connections/setConnectionsDownloadParams', params);
    },
    handleShowDetails() {
      this.$EventBus.$emit('ConnectionsListItem/SHOW_DETAILS_AND_ACTIONS', this.item);
    },
  },
};
